import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import logoSm from "../../../assets/icons/logo-1.jpg";
import { ReadCountriesService } from "../../../services/general";
import { CheckUserService, UserRegistrationService } from "../../../services/user";
import "../auth-common.css";
import Layout from "../Layout";
import "./registration.css";
var Messages = require('./RegistrationMessages.json');

const Registration = () => {
    const [isPasswordFieldEnabled, setIsPasswordFieldEnabled] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [countries, setCountries] = useState([]);
    const [messages, setMessages] = useState({});
    const [formData, setFormData] = useState({
        mobile: "",
        password: "",
        confirmPassword: "",
        countryCode: "",
        checkTc: false
    });
    const [formErrors, setFormErrors] = useState({
        mobile: "",
        password: "",
        confirmPassword: "",
        countryCode: "",
        checkTc: ""
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };

    const handleInputChange = (e) => {
        const { name, type, checked, value } = e.target;
        if (name === "mobile" && (value.startsWith("0") || value.length > 10 || /[^0-9]/.test(value))) {
            return;
        }
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const validatePassword = (password) => {
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        return passwordRegex.test(password);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const countryCodeError = formData.countryCode ? "" : "Country Code cannot be Blank";
        const mobileError = formData.mobile ? "" : "Mobile cannot be Blank";
        setFormErrors({
            countryCode: countryCodeError,
            mobile: mobileError,
        });
        let mobile = '+' + formData.countryCode.split('_')[0] + formData.mobile;
        setLoading(true);
        if (!isPasswordFieldEnabled){
            let temp_check_user = await CheckUserService(mobile);
            let temp_data = temp_check_user.data;
            if (temp_data && temp_data.is_check){
                if (temp_data.is_exists) {
                    toast.success(messages.already_registered.english);
                    toast.success(messages.already_registered.arabic);
                    navigate('/');
                }
                else{
                    if (temp_data.is_temp_customer) {
                        setIsPasswordFieldEnabled(true);
                    }
                    else {
                        toast.error(messages.unable_to_register.english);
                        toast.error(messages.unable_to_register.arabic);
                        navigate('/');
                    }
                }
            } else {
                setFormErrors({
                    mobile: temp_check_user.detail,
                });
            }
        }
        else{
            if (!formData.checkTc){
                toast.error("Please agree to the Terms & Conditions before submitting, to enable the terms & condition checkbox, click on a link.");
                setLoading(false);
                return;
            }
            let passwordError = formData.password ? "" : "Password cannot be Blank";
            let confirmPasswordError = formData.confirmPassword ? "" : "Confirm Password cannot be Blank";
            const passwordMatchingError = formData.password === formData.confirmPassword ? "" : "Password and Confirm Password is not same";
            const checkTcError = formData.checkTc ? "" : "Terms & Conditions must be checked";
            if (!passwordError){
                passwordError = validatePassword(formData.password) ? "" : "Password must be at least 8 characters long and contain letters, symbols and numbers";
            }
            if (!confirmPasswordError){
                confirmPasswordError = validatePassword(formData.confirmPassword) ? "" : "Password must be at least 8 characters long and contain letters, symbols and numbers";
            }
            setFormErrors({
                password: passwordError,
                confirmPassword: confirmPasswordError,
                passwordMatching: passwordMatchingError,
                checkTc: checkTcError
            });
            if (!passwordError && !confirmPasswordError && !passwordMatchingError && !checkTcError) {
                let temp_user_registration = await UserRegistrationService(mobile, formData.password, formData.countryCode.split('_')[1], formData.checkTc);
                if (temp_user_registration.success){
                    toast.success(messages.registered_success.english);
                    toast.success(messages.registered_success.arabic);
                    navigate('/');
                } else {
                    toast.error(temp_user_registration.message);
                    navigate('/');
                }
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        (async () => {
            setLoading(true);
            setMessages(Messages);
            let temp_countries = await ReadCountriesService();
            if (temp_countries) {
                setCountries(temp_countries);
                if (temp_countries.length === 1) {
                    setFormData((formData) => ({
                        ...formData,
                        countryCode: temp_countries[0].phone_code + '_' + temp_countries[0].code
                    }));
                }
            }
            setLoading(false);
        })();
    }, []);

    return (
        <Layout>
            <div className="form-container">
                <div className="logo-wrapper">
                    <img src={logoSm} alt="" />
                </div>
                <h1 className="auth-title">Create Account</h1>
                <form onSubmit={handleSubmit} className="auth-form signup">
                    <div className="form-group-dx">
                        <label htmlFor="mobile">Mobile Number</label>
                        <div className="form-group-country-mobile">
                            <div className="form-group-country">
                                <select id="countryCode" name="countryCode" required
                                    value={formData.countryCode} onChange={handleInputChange}>
                                    <option>Select Country</option>
                                    {countries.map((country) => {
                                        return (
                                            <option key={country.id} value={country.phone_code + '_' + country.code}>
                                                +{country.phone_code} - {country.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            <div className="form-group-mobile">
                                <input
                                    type="tel"
                                    id="mobile"
                                    name="mobile"
                                    value={formData.mobile}
                                    placeholder="Enter mobile number"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>
                        {formErrors.countryCode && <p className="error">{formErrors.countryCode}</p>}
                        {formErrors.mobile && <p className="error">{formErrors.mobile}</p>}
                    </div>
                    {!isPasswordFieldEnabled ?
                        <button type="submit" className="submit-button dx-btn-primary" disabled={loading}>
                            {loading ? "Submittimg ..." : "Submit"}
                        </button>
                    : ''}
                    {isPasswordFieldEnabled ? <>
                        <div className="form-group-dx">
                            <span className="password-label-wrapper">
                                <label htmlFor="password">Password</label>
                                <button
                                    type="button"
                                    className="toggle-password"
                                    onClick={togglePasswordVisibility}
                                >
                                    {passwordVisible ? "Hide" : "Show"}
                                </button>
                            </span>
                            <div className="password-container">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    placeholder="Enter password"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            {formErrors.password && (
                                <p className="dx-lib input-error">{formErrors.password}</p>
                            )}
                            <span className="password-label-wrapper">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <button
                                    type="button"
                                    className="toggle-password"
                                    onClick={toggleConfirmPasswordVisibility}
                                >
                                    {confirmPasswordVisible ? "Hide" : "Show"}
                                </button>
                            </span>
                            <div className="password-container">
                                <input
                                    type={confirmPasswordVisible ? "text" : "password"}
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    placeholder="Enter password"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <p className="password-hint">
                                Use 8 or more characters with a mix of letters, numbers & symbols
                            </p>
                            {formErrors.confirmPassword && (
                                <p className="dx-lib input-error">{formErrors.confirmPassword}</p>
                            )}
                            {formErrors.passwordMatching && (
                                <p className="dx-lib input-error">{formErrors.passwordMatching}</p>
                            )}
                            <div>
                                <input type="checkbox" id="checkTc" name="checkTc"
                                    onChange={handleInputChange}
                                    title="Please read terms and conditions carefully to enable checkbox"/>
                                <label htmlFor="checkTc" id="check_tc_label">I agree to the
                                    <a href="/" target="_blank" rel="noopener noreferrer" style={{"marginLeft": "2px"}}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.open("/files/terms-and-conditions.pdf", "_blank", "noopener,noreferrer");
                                    }}>
                                        Terms & Conditions
                                    </a>
                                </label>
                                {formErrors.checkTc && (
                                    <p className="dx-lib input-error">{formErrors.checkTc}</p>
                                )}
                            </div>
                        </div>
                        <button type="submit" className="submit-button dx-btn-primary" disabled={loading}>
                            {loading ? "Creating Account ..." : "Create Account"}
                        </button>
                        </> : ''}
                </form>
            </div>
        </Layout>
    );
};

export default Registration;